
import csstype.ClassName
import org.w3c.xhr.XMLHttpRequest
import react.FC
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.div
import react.useState

fun getImages(stone: AsPacStoneType): String {
    val url = "phpscripts/displayimages.php?stype=${stone.stoneName}pictures"
    val xmlHttp = XMLHttpRequest()
    xmlHttp.open("GET", url, false)
    xmlHttp.send()
    return xmlHttp.responseText
}

val ShowSampleImages = FC<sampleProp>{props ->
    var sampleHighRange by useState(props.highIterator)
    val additionalImages = 8

    val filenames = getImages(props.stoneType)
    val tempFilesList = filenames.split(",")
    var filesList = mutableListOf<StoneSample>()

    tempFilesList.forEach { filename ->
        if (!filename.isNullOrEmpty())
        filesList.add(StoneSample(filename.substringBefore("."), filename))
    }

    var highRange =
        if (filesList.size - 1 <= sampleHighRange)
            filesList.size - 1
        else
            sampleHighRange

    div {
        className = ClassName("allCards")
        for (iterator in 0..highRange) {
            div {
                className = ClassName("card")
                ReactHTML.img {
                    src = "${props.stoneType.stoneName}pictures/${filesList[iterator].filename}"
                    className = ClassName("thumbnail")
                }
                div {
                    className = ClassName("container")
                    ReactHTML.h4 {
                        +filesList[iterator].name
                    }
                }
            }
        }
        if (sampleHighRange < filesList.size - 1) {
            ReactHTML.button {
                +"Load more..."
                className = ClassName("loadMoreBtn")
                onClick = {
                    sampleHighRange =
                        if (sampleHighRange + additionalImages <= filesList.size - 1)
                            sampleHighRange + additionalImages
                        else
                            filesList.size - 1
                }
            }
        }

        if (sampleHighRange >= filesList.size - 1 && props.stoneType.stoneName == "limestone") {
            div {
                className = ClassName("supplierSite")
                + "For more color please visit one of our suppliers' page: "
                a {
                    href = "https://en.kasaquartz.cn/product/33/"
                    + "Kasa Quartz"
                }
            }
        }
    }
}